export default "__VITE_ASSET__ec63fc90__"